import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as CopyText } from 'assets/svg/icon-copy.svg'

function IconCopyText(props: IconProps): JSX.Element {
  const title = 'icon-copy'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <CopyText {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconCopyText
